import { addAction, addFilter } from '@situation/setdesign.util';

class CalendarPrint {
    constructor($container) {
        this.$container = $container;
        this.html = $container.find('.calendar-print').html();
        this.url = $container.data('print');

        if (this.url && this.html) {
            addFilter('calendar/settings', this.settings, 10, this);
            addAction('calendar/viewRender', this.render, 10, this);
        }
    }

    settings(settings) {
        const printButton = {
            text: ' ',
            click: () => {
                window.open(this.url, '_blank');
            },
        };
        const customButtons = { ...(settings.customButtons || {}), print: printButton };
        const header = { ...(settings.header || {}), right: 'print' };
        return { ...settings, customButtons, header };
    }

    render() {
        this.$container.find('.fc-print-button').html(this.html);
    }
}

export default CalendarPrint;
